import { observable } from '@legendapp/state';

// Online/Offline status tracking
export const sync$ = observable({
  isOnline: typeof navigator !== 'undefined' ? navigator.onLine : true,
  isSyncing: false,
  lastSyncTime: null,
  pendingChanges: 0,
  error: null,
});

// Listen for online/offline events
if (typeof window !== 'undefined') {
  window.addEventListener('online', () => {
    sync$.isOnline.set(true);
    sync$.error.set(null);
  });
  
  window.addEventListener('offline', () => {
    sync$.isOnline.set(false);
  });
}

// Helper functions
export const setSyncing = (isSyncing) => {
  sync$.isSyncing.set(isSyncing);
  if (!isSyncing) {
    sync$.lastSyncTime.set(Date.now());
  }
};

export const setSyncError = (error) => {
  sync$.error.set(error);
};

export const incrementPending = () => {
  sync$.pendingChanges.set(sync$.pendingChanges.get() + 1);
};

export const decrementPending = () => {
  const current = sync$.pendingChanges.get();
  sync$.pendingChanges.set(Math.max(0, current - 1));
};

export const clearPending = () => {
  sync$.pendingChanges.set(0);
};

